<template>
    <v-content>
        <v-container fluid grid-list-lg>
            <v-layout row wrap>
                <template v-for="match in matches">
                    <v-flex v-bind:key="match['.key']" xs12>
                        <v-card v-bind:color="match.date.toDate() >= new Date() ? 'blue-grey darken-2' : 'blue-grey darken-5'" class="white--text">
                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">{{ match.hometeam }} vs {{ match.description }}
                                        ({{match.date.toDate().toLocaleDateString('nl-BE')}})</h3>
                                    <div>{{match.places - (match.placesSold || 0) - (match.type === 'regular' ? getTotalSubscriptions : 0)}} aantal plaatsen vrij, {{match.placesSold}} plaatsen verkocht.
                                        <template v-if="match.type === 'regular'">{{getTotalSubscriptions}} plaatsen gereserveerd</template></div>
                                </div>
                            </v-card-title>
                            <v-card-actions>
                                <template>
                                    <router-link :to="{ name: 'match', params: { id: match['.key'] }}">
                                        <v-btn flat dark>Tickets</v-btn>
                                    </router-link>
                                    <v-btn flat dark @click="editMatch(match)">Bewerken</v-btn>
                                </template>
                                <template>
                                    <router-link :to="{ name: 'report', params: { id: match['.key'] }}">
                                        <v-btn flat dark>Rapport</v-btn>
                                    </router-link>
                                </template>
                                <v-spacer></v-spacer>
                                <v-btn flat color="red" @click="deleteMatch(match)">Delete</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>
        <v-btn
                fab
                bottom
                right
                color="pink"
                dark
                fixed
                @click.stop="dialog = !dialog"
        >
            <v-icon>add</v-icon>
        </v-btn>
        <MatchDialog :dialog="dialog" v-on:closeDialog="dialog = false" :match-dates="getMatchDates" :selectedMatch="selectedMatch"/>
    </v-content>
</template>

<script>
import { db } from "../../firebase";
import MatchDialog from "../components/MatchDialog";
import dateFormat from "dateformat";

export default {
  components: { MatchDialog },
  name: "Calendar",
  props: {
    msg: String
  },
  data() {
    return {
      matches: [],
      dialog: false,
      selectedMatch: null,
      subscriptionReports: []
    };
  },
  computed: {
    getMatchDates: function() {
      const returnArray = [];
      this.matches.forEach(match => {
        returnArray.push(dateFormat(match.date.toDate(), "isoDate"));
      });

      return returnArray;
    },
    getTotalSubscriptions: function() {
      if (this.subscriptionReports && this.subscriptionReports[0]) {
        return this.subscriptionReports[0].totals.originalTotalSubscriptions;
      }

      return 0;
    }
  },
  firestore() {
    const today = new Date();
    let lastmonth = new Date();
    lastmonth.setDate(today.getDate() - 30);

    return {
      matches: db
        .collection("matches")
        .where("date", ">", lastmonth)
        .orderBy("date"),
      subscriptionReports: db.collection("subscription-reports").orderBy("year").limit(1)
    };
  },
  methods: {
    deleteMatch: function(match) {
      if (confirm("Ben je zeker?")) {
        db.collection("matches")
          .doc(match[".key"])
          .delete();
      }
    },
    editMatch: function(match) {
      this.selectedMatch = match;
      this.dialog = !this.dialog;
    }
  }
};
</script>
